import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap'; // Make sure to import the Button component
import TourLogo from '../assets/img/TourLogo.png';

function EventMap2() {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/event-map'); // Replace with the actual route you want to navigate to
  };

  return (
    <div className="fade-in">
        <hr style={{color:'#fff'}}/>
      <h4 style={{color:'#61bcf1dd'}}>
        For additional info check out Albania's main touristic cities through our map!
       
      </h4>
      <hr />
      <Button onClick={handleButtonClick} className="Eventbutton">Event Map</Button>
    <hr style={{color:'#fff'}}/>
    </div>
  );
}

export default EventMap2;
